import ColorTokenTable from './ColorTokenTable';

export default ColorTokenTable;
